import React from "react";
import { motion } from "framer-motion";
import { Song } from "../../types/song";

interface LyricsProps {
  song: Song;
}

const Lyrics: React.FC<LyricsProps> = ({ song }) => {
  if (!song.lyrics?.trim()) return null;

  return (
    <section id="song-lyrics" className="py-12 px-6 bg-gradient-to-br from-purple-50 to-blue-50">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-2xl mx-auto text-center"
      >
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-3">Lyrics</h2>
        <div className="w-24 h-1 bg-purple-600 mx-auto mb-6" />
        <p className="whitespace-pre-line text-lg md:text-xl leading-loose text-gray-700 font-light">
          {song.lyrics}
        </p>
      </motion.div>
    </section>
  );
};

export default Lyrics;
